

























































import Vue from 'vue';
import { get } from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import { downloadImportTemplate } from '@/pages/import/download';

export default Vue.extend({
  name: 'SorListingZeroState',
  props: {
    objectType: {
      type: String,
      default: '',
    },
    blockTitle: {
      type: String,
      default: '',
    },
    objectTypesMeta: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters(['csrfToken', 'routes']),

    objectTypeSingular() {
      return get(this.objectTypesMeta, [this.objectType, 'nameSingular'], null);
    },
    objectTypePlural() {
      return get(this.objectTypesMeta, [this.objectType, 'namePlural'], null);
    },
    canCreate() {
      return get(this.objectTypesMeta, [this.objectType, 'isCreatable'], null);
    },
    canImport() {
      return get(this.objectTypesMeta, [this.objectType, 'isImportable'], null);
    },
    opensCreateDialog() {
      return get(this.objectTypesMeta, [this.objectType, 'opensCreateCard'], null);
    },
    createUrl() {
      if (this.objectType === 'SurveyTemplate') {
        return '/survey_builder/new';
      }
      return this.routes.sorNewObject.replace('__OBJECT_TYPE__', this.objectType);
    },
  },
  methods: {
    ...mapActions({
      showModal: 'modals/show',
    }),
    downloadCsvTemplate() {
      const typeFilename = this.objectTypePlural
        .split(' ')
        .join('')
        .toLowerCase();
      const filename = `import_${typeFilename}_template.csv`;

      const data = [
        {
          object_name: this.objectType,
          fields: 'all',
        },
      ];

      downloadImportTemplate(filename, data, this.csrfToken);
    },
    async openCreateDialog() {
      try {
        await this.showModal({
          type: 'NewObject',
          data: {
            url: this.createUrl,
            type: this.objectTypeSingular,
          },
        });
        this.$emit('objectCreate', this.objectTypeSingular);
      } catch (e) {
        // User canceled modal
      }
    },
  },
});
